import { connect } from 'react-redux';

import { CapAction } from 'src/components/CapAction/CapAction';
import { UserRole } from 'src/utils/auth/constants';

const mapStateToProps = ({ currentUser: { data: { roles } } }) => {
  const roleNameArray = roles.map(r => r.name);

  return {
    isCapManager: roleNameArray.includes(UserRole.CapManager),
    isFactoryUser: roleNameArray.includes(UserRole.FactoryUser),
    isExternalUser: roleNameArray.some(role => [UserRole.FactoryUser, UserRole.VendorUser].includes(role)),
    isAdmin: roleNameArray.includes(UserRole.Admin)
  };
};

export const CapActionContainer = connect(mapStateToProps)(CapAction);
